function toggleCustomAccordions() {
  const containers = document.querySelectorAll('.expand-container');

  if (containers.length === 0) return;

  containers.forEach((item) => {
    const expand = item.querySelector('.expand');
    const content = item.querySelector('.expand-content');

    // Initialzustand setzen
    content.style.height = '0px';
    content.setAttribute('aria-expanded', 'false');

    expand.addEventListener('click', function () {
      const isExpanded = content.getAttribute('aria-expanded') === 'true';

      if (!isExpanded) {
        this.classList.add('expanded');
        const height = content.scrollHeight;
        content.style.height = height + 'px';
        content.setAttribute('aria-expanded', 'true');

        // optional: nach Übergang Höhe auf 'auto' setzen
        setTimeout(() => {
          if (content.getAttribute('aria-expanded') === 'true') {
            content.style.height = 'auto';
          }
        }, 300); // Dauer entsprechend Ihrer CSS-Transition
      } else {
        this.classList.remove('expanded');
        content.style.height = content.scrollHeight + 'px'; // für sauberen Übergang
        requestAnimationFrame(() => {
          content.style.height = '0px';
        });
        content.setAttribute('aria-expanded', 'false');
      }
    });
  });
}


function toggleCatFilter() {
  const triggers = document.querySelectorAll('#media-format-selection button');
  const filter = document.querySelector('#media-category-filter');

  if (triggers.length === 0 || !filter) return;

  // Initialzustand setzen
  filter.style.height = '0px';
  filter.setAttribute('aria-expanded', 'false');

  triggers.forEach((item) => {
    item.addEventListener('click', function () {
      const isExpanded = filter.getAttribute('aria-expanded') === 'true';

      if (!isExpanded) {
        const height = filter.scrollHeight;
        filter.style.height = height + 'px';
        filter.setAttribute('aria-expanded', 'true');

        // optional: danach wieder auf auto setzen
        setTimeout(() => {
          if (filter.getAttribute('aria-expanded') === 'true') {
            filter.style.height = 'auto';
          }
        }, 300);
      } else {
        filter.style.height = filter.scrollHeight + 'px';
        requestAnimationFrame(() => {
          filter.style.height = '0px';
        });
        filter.setAttribute('aria-expanded', 'false');
      }
    });
  });
}
